<template>
<body :id="`handsontable-design${report_id}`">
  <div class="col-xs-12" layoutH="20">
    <div  ref="example" :id="report_id+'mini'" :name="report_name" class="ht-example handsontable"></div>
  </div>
</body>
</template>
<script>
import { HChtHelper, sendDesignThistoHelper } from '../../../static/handsontable/js/hc.handsontables.helper.js'
import { sendThistoHandson } from '../../../static/handsontable/js/jquery.handsontable.full.js'
export default {
  name: 'handsontable-design',
  props: {
    report_id: String,
    report_name: {
      type: String,
      default: 'name'
    },
    type: {
      type: String,
      default: 'mini'
    },
    height: {
      type: Number,
      default: 380
    }
  },
  data () {
    return {
      settings: {},
      loading: true
      // reportId: this.report_id,
      // item: {
      //   id: '',
      //   name: this.report_name,
      //   row: '',
      //   col: ''
      // }
    }
  },
  watch: {
    // item: {
    //   handler (val, oldVal) {
    //     val.id = this.report_id
    //     this.$emit('item', val)
    //   },
    //   deep: true
    // }
  },
  mounted () {
    sendThistoHandson(this)
    sendDesignThistoHelper(this)
  },
  computed: {

  },
  methods: {
    initTemplate () {
      let _this = this
      // let blankContent = false
      this.$store.commit('SET_BLANKCONTENT', false)
      if (!_this.settings) {
        this.$store.commit('SET_BLANKCONTENT', true)
        _this.settings = {}
        _this.settings.data = HChtHelper.Common.loadTableData(5, 10)
        _this.settings.height = _this.height
        _this.settings.excelDownload = '../common/exportHtmlToExcel'
        if (_this.type === 'mini') {
          _this.settings.toolbar = {
            'type': 'mini',
            miniMenu: [ 'stretch']
          }
          delete _this.settings.contextMenu
          delete _this.settings.colHeaders
          delete _this.settings.rowHeaders
          delete _this.settings.minSpareRows
          delete _this.settings.minSpareCols
          $(`#${this.report_id}mini`).HChtHelper(_this.settings)
        } else {
          $(`#${this.report_id}`).HChtHelper(_this.settings)
        }
      } else {
        _this.settings.height = _this.height
        _this.settings.excelDownload = '../common/exportHtmlToExcel'
        if (!_this.settings.data || !_this.settings.data.length) {
          this.$store.commit('SET_BLANKCONTENT', true)
          _this.settings.data = HChtHelper.Common.loadTableData(10, 10)
        }
        if (!_this.settings.ruleData.length) {
          _this.settings.ruleData = [[]]
        }
        if (!_this.settings.styleData.length) {
          _this.settings.styleData = [[]]
        }
        if (_this.type === 'mini') {
          _this.settings.toolbar = {
            'type': 'mini',
            miniMenu: ['stretch']
          }
          delete _this.settings.contextMenu
          delete _this.settings.colHeaders
          delete _this.settings.rowHeaders
          delete _this.settings.minSpareRows
          delete _this.settings.minSpareCols
          $(`#${this.report_id}mini`).HChtHelper(_this.settings)
        } else {
          $(`#${this.report_id}`).HChtHelper(_this.settings)
        }
      }
    },
    // 获取当前表的大字段
    getContent () {
      let HChthelper = null
      if (this.type === 'mini') {
        HChthelper = $(`#${this.report_id}mini`).data('hchthelper')
      } else {
        HChthelper = $(`#${this.report_id}`).data('hchthelper')
      }
      let content = JSON.stringify(HChthelper.saveParams(false))
      return content
    },
    // 初始化报表
    initData (data) {
      this.settings = JSON.parse(null)
      // 初始化报表工具 当前报表的id
      if (this.report_id === 'new') {
        this.$store.commit('SET_REPORT_CODE', this.report_id)
        this.initTemplate()
        this.loading = false
      } else {
        this.settings = data.datacontent
        this.$store.commit('SET_REPORT_CODE', data.id)
        this.initTemplate()
        this.loading = false
      }
    },
    // 非异步，初始化本地数据
    localInitData (resArr) {
      let res = resArr.find((item) => {
        if (item.id === this.report_id) return item
      })
      this.settings = JSON.parse(res.report_content)
      this.$store.commit('SET_REPORT_CODE', res.id)
      this.initTemplate()
      this.loading = false
    }
  }
}
</script>
<style>
/* matrix.min.css */

@import '../../../static/handsontable/css/handsontable.full.css';
@import '../../../static/handsontable/css/hc.handsontable.helper.css'
</style>



// WEBPACK FOOTER //
// src/components/handsontable/design.vue